import { parse } from 'date-fns';

import { SERVER_DATE_FORMAT } from './constants.js';

export const getDateFormValue = (value: string) => {
  if (!value) {
    return null;
  }

  return parse(value, SERVER_DATE_FORMAT, new Date());
};
